
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FusionContent, FusionContentCaptivate, FusionContentHtmlPage, FusionContentIframely, FusionContentLxt, FusionContentMiroByTemplate, FusionContentMiroByUrl, FusionContentRise, FusionContentStoryline, FusionContentVideo, FusionContentYoutube, FustionTypeArr, SpfBucketFileFrontend } from '@shared/index';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { LanguageService } from '@shared-angular/services/language.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ManualLinkComponent } from "../../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { FusionService } from '@shared-angular/services/fusion.service';
import { ZipexportService } from '../../../../../../../shared/services/zipexport/zipexport.service';
import { runBotBatch } from '../../../../../../../shared/services/bot-bulk-actions';
import { BulkAction, BulkActionBarComponent } from '../../../../../../../shared/components/bulk-action-bar/bulk-action-bar.component';
import { FusionBotDetatailComponent } from './fusion-bot-detatail/fusion-bot-detatail.component';
import { capitalizeOrParse } from './fusionbot-tab.utils';
export { capitalizeOrParse };

type FusionActionRow = {
  _id: string;
  metadata: {
    type: string;
    botId: string;
  };
};

@Component({
  selector: 'app-fusionbot-tab',
  imports: [
    FormsModule,
    BadgeModule,
    OverlayBadgeModule,
    ManualLinkComponent,
    MenuModule,
    ButtonModule,
    MessageModule,
    CardModule,
    InputTextModule,
    SelectModule,
    TooltipModule,
    TableModule,
    ConfirmDialogModule,
    DialogModule,
    DrawerModule,
    FusionBotDetatailComponent,
    BulkActionBarComponent
],
  providers: [ConfirmationService],
  templateUrl: './fusionbot-tab.component.html',
  styleUrl: './fusionbot-tab.component.scss'
})
export class FusionbotTabComponent {
  public get bulkActions(): BulkAction[] {
    return [
      {
        id: 'bulk-delete',
        label: $localize`:@@bulk-delete:Löschen`,
        icon: 'ri-delete-bin-line',
        disabled: this.bulkBusy,
        command: () => this.confirmBulkDelete()
      }
    ];
  }

  private static readonly MIRO_TYPES = new Set(['miro-by-template', 'miro-by-url']);
  private actionMenuCache = new Map<string, MenuItem[]>();

  public showDrawer = false;
  public selectedFusionContents: SpfBucketFileFrontend<string, FusionContent<string>>[] = [];
  public bulkBusy = false;
  public bulkFailedNames = '';

  public fusionTypes = FustionTypeArr;
  //? Wenn mehr als Capitalization dann in capitalizeOrParse anpassen
  //  public iframelyTypes = [ 'vimeo'];
  public capitalizeOrParse = capitalizeOrParse;
  public title: string = '';
  public type: FusionContent<string>["type"] = 'htmlpage';
  public showCreateDialog = false;
  public showTitleDialog = false;
  public typeFilter: string = '';
  public typeInfo: Record<string, { img?: string; icon?: string; desc: string }> = {
    'captivate': { img: 'assets/iframely/captivate.png', desc: $localize`:@@type-desc-captivate:Adobe Captivate E-Learning einbetten` },
    'htmlpage': { img: 'assets/iframely/htmlpage.png', desc: $localize`:@@type-desc-htmlpage:Komplette Seite frei gestalten` },
    'html-as-media': { icon: 'ri-code-box-line', desc: $localize`:@@type-desc-html-as-media:HTML per Editor oder iframe einbinden` },
    'iframely_vimeo': { img: 'assets/iframely/vimeo.png', desc: $localize`:@@type-desc-vimeo:Vimeo-Videos einbetten` },
    'knowledgeworker': { img: 'assets/iframely/knowledgeworker.png', desc: $localize`:@@type-desc-knowledgeworker:Knowledgeworker-Inhalte einbinden` },
    'lxt': { img: 'assets/iframely/lxt.png', desc: $localize`:@@type-desc-lxt:LXT-Lerninhalte einbinden` },
    'miro-by-url': { img: 'assets/iframely/miro.png', desc: $localize`:@@type-desc-miro-url:Miro-Board per URL einbinden` },
    'miro-by-template': { img: 'assets/iframely/miro.png', desc: $localize`:@@type-desc-miro-template:Miro-Board aus Vorlage erstellen` },
    'rise': { img: 'assets/iframely/rise.png', desc: $localize`:@@type-desc-rise:Articulate Rise-Kurse einbetten` },
    'storyline': { img: 'assets/iframely/storyline.png', desc: $localize`:@@type-desc-storyline:Articulate Storyline-Kurse einbetten` },
    'youtube': { img: 'assets/iframely/youtube.png', desc: $localize`:@@type-desc-youtube:YouTube-Videos einbetten` }
  };

  constructor(
    protected rss: RouteShareService,
    public fusionService: FusionService,
    public langService: LanguageService,
    public zipexportService: ZipexportService,
    private confirmationService: ConfirmationService
  ) { }

  public openCreateDialog() {
    this.title = '';
    this.type = 'htmlpage';
    this.typeFilter = '';
    this.showCreateDialog = true;
  }

  public selectType(t: string) {
    this.type = t as FusionContent<string>["type"];
    this.showCreateDialog = false;
    this.title = '';
    this.showTitleDialog = true;
  }

  public createFusion() {
    if (!this.title.trim()) return;
    void this.fusionService.createFusionConfig(this.title.trim(), this.type);
    this.showTitleDialog = false;
    this.title = '';
    this.type = 'htmlpage';
    this.typeFilter = '';
  }

  public backToTypeSelection() {
    this.showTitleDialog = false;
    this.showCreateDialog = true;
  }

  public selectTypeAndCreate(t: string) {
    this.type = t as FusionContent<string>["type"];
    if (this.fusionService.fusionContent.length === 0) {
      this.typeFilter = '';
      this.title = '';
      this.showTitleDialog = true;
    }
  }

  public getFilteredTypes(): string[] {
    const types = this.getTypes();
    if (!this.typeFilter.trim()) return types;
    const filter = this.typeFilter.toLowerCase();
    return types.filter(t => {
      const name = this.capitalizeOrParse(t).toLowerCase();
      const desc = (this.typeInfo[t]?.desc ?? '').toLowerCase();
      return name.includes(filter) || desc.includes(filter);
    });
  }

  public async onRowReorder(_event: unknown) {
    const items = this.fusionService.fusionContent;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (!item) continue;
      const newPos = i + 1;
      if (item.metadata.sortFloat !== newPos) {
        item.metadata.sortFloat = newPos;
        await this.fusionService.updateFusionFieldFor(item._id, 'sortFloat', newPos);
      }
    }
  }

  public isUrlValid(url: string): boolean {
    if (url == '') return true;
    return /(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})[/\w .-]*\/?/.test(url);
  }

  public filterDisabledTypes(): string[] {
    return this.fusionTypes.filter(type => !['video', 'iframely', 'html-as-media'].includes(type));
  }

  public getTypes() {
    const types = this.filterDisabledTypes();
    //  this.iframelyTypes.forEach(t => types.push('iframely_' + t));
    return types;
  }

  public getFusionActionMenuItems(fusionContent: FusionActionRow): MenuItem[] {
    const cacheKey = `${fusionContent._id}-${fusionContent.metadata.type}`;
    const cachedItems = this.actionMenuCache.get(cacheKey);
    if (cachedItems) {
      return cachedItems;
    }

    const items: MenuItem[] = [
      {
        label: $localize`:@@open:Öffnen`,
        icon: 'ri-external-link-line',
        url: `/${this.langService.getLanguage()}/fusion/${this.rss.botConfig._id}/${fusionContent._id}`,
        target: `_fusion${fusionContent.metadata.type}`
      },
      {
        label: $localize`:@@edit:Bearbeiten`,
        icon: 'ri-pencil-fill',
        command: () => this.openDrawer(fusionContent._id)
      },
      {
        label: $localize`:@@delete-fusionview:Fusionview löschen`,
        icon: 'ri-close-large-fill',
        command: () => this.confirmDeleteFusionView(fusionContent)
      }
    ];

    this.actionMenuCache.set(cacheKey, items);
    return items;
  }

  public openDrawer(fusionId: string) {
    const fc = this.fusionService.fusionContent.find(f => f._id === fusionId);
    if (!fc) return;
    this.fusionService.selectedFusionContent = fc;
    this.fusionService.selectedHtmlPage = fc as SpfBucketFileFrontend<string, FusionContentHtmlPage>;
    this.fusionService.selectedRise = fc as SpfBucketFileFrontend<string, FusionContentRise>;
    this.fusionService.selectedVideo = fc as SpfBucketFileFrontend<string, FusionContentVideo>;
    this.fusionService.selectedIframely = fc as SpfBucketFileFrontend<string, FusionContentIframely>;
    this.fusionService.selectedYoutube = fc as SpfBucketFileFrontend<string, FusionContentYoutube>;
    this.fusionService.selectedStoryline = fc as SpfBucketFileFrontend<string, FusionContentStoryline>;
    this.fusionService.selectedCaptivate = fc as SpfBucketFileFrontend<string, FusionContentCaptivate>;
    this.fusionService.selectedLxt = fc as SpfBucketFileFrontend<string, FusionContentLxt>;
    this.fusionService.selectedMiroByTemplate = fc as SpfBucketFileFrontend<string, FusionContentMiroByTemplate>;
    this.fusionService.selectedMiroByUrl = fc as SpfBucketFileFrontend<string, FusionContentMiroByUrl>;
    this.showDrawer = true;
  }

  public openFusionPreview() {
    const fc = this.fusionService.selectedFusionContent;
    if (!fc) return;
    window.open('/' + this.langService.getLanguage() + '/fusion/' + fc.metadata.botId + '/' + fc._id, '_fusion');
  }

  public confirmBulkDelete(): void {
    if (this.bulkBusy || !this.selectedFusionContents.length) return;
    const toDelete = [...this.selectedFusionContents];
    const count = toDelete.length;
    this.confirmationService.confirm({
      header: $localize`:@@bulk-delete-fusionviews-header:${count}:count: Fusion-View(s) löschen?`,
      icon: 'ri-error-warning-line',
      message: $localize`:@@bulk-delete-fusionviews-message:Möchtest du ${count}:count: Fusion-View(s) wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`,
      rejectButtonProps: {
        label: $localize`:@@delete-reject:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@delete-accept:Löschen`,
        severity: 'danger'
      },
      accept: async () => {
        if (this.bulkBusy) return;
        this.bulkBusy = true;
        this.bulkFailedNames = '';
        try {
          const result = await runBotBatch(toDelete, (id, fc) => this.fusionService.delete(fc.metadata.botId, id));
          this.selectedFusionContents = result.failed;
          this.bulkFailedNames = result.failed.map(fc => fc.metadata.title).join(', ');
        } finally {
          this.bulkBusy = false;
        }
      }
    });
  }

  private confirmDeleteFusionView(fusionContent: FusionActionRow) {
    this.confirmationService.confirm({
      header: $localize`:@@delete-fusionview-confirmation:Fusionview löschen?`,
      message: $localize`:@@delete-fusionview-message:Möchtest du diese Fusionview wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`,
      icon: 'ri-error-warning-line',
      rejectButtonProps: {
        label: $localize`:@@delete-reject:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@delete-accept:Löschen`,
        severity: 'danger'
      },
      accept: () => {
        void this.fusionService.delete(fusionContent.metadata.botId, fusionContent._id);
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
}
